"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailValid = exports.EMAIL_ADDRESS_REGEX = void 0;
exports.EMAIL_ADDRESS_REGEX = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const emailValid = (email) => {
    if (typeof email === 'string') {
        const validateRes = exports.EMAIL_ADDRESS_REGEX.test(email);
        return validateRes;
    }
    return false;
};
exports.emailValid = emailValid;
